import { useState } from 'react';
import axios from 'axios';
import { Loader2, Play } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function MegaTierRunButton({ job, meta, onStarted }) {
  const [busy, setBusy] = useState(false);
  const running = !!job?.in_progress;
  const run = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/admin/cron/run/job/mega_tier`, {}, { withCredentials: true });
      toast.success('Mega Tier funnel started — refreshes when done');
      onStarted?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail?.message || e?.response?.data?.detail || 'Could not start job');
    } finally { setBusy(false); }
  };
  const last = meta?.computed_at ? new Date(meta.computed_at).toLocaleString() : 'never';
  return (
    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-testid="mega-tier-admin-bar">
      <span data-testid="mega-tier-last-run">Last run: {last}{meta?.elapsed_s ? ` · ${meta.elapsed_s}s` : ''}</span>
      {running && (
        <span className="inline-flex items-center gap-1 text-amber-500" data-testid="mega-tier-running">
          <Loader2 className="w-3 h-3 animate-spin" /> {job.progress || 'running'} {job.in_progress_processed}/{job.in_progress_total}
        </span>
      )}
      <Button size="sm" variant="outline" onClick={run} disabled={busy || running} data-testid="mega-tier-run-now-btn">
        <Play className="w-3 h-3 mr-1" /> Run now
      </Button>
    </div>
  );
}
